import { FC } from "react";

interface ToggleOffSVGProps {
    width?: number;
    height?: number;
}

const ToggleOffSVG: FC<ToggleOffSVGProps> = ({ width = "18px", height = "18px" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M7.99988 15.5C6.21504 15.5 4.72206 14.137 4.53586 12.3681C4.51022 12.1245 4.51022 11.8755 4.53586 11.6319C4.72206 9.86302 6.21504 8.5 7.99987 8.5C9.78471 8.5 11.2777 9.86302 11.4639 11.6319C11.4895 11.8755 11.4895 12.1245 11.4639 12.3681C11.2777 14.137 9.78471 15.5 7.99988 15.5Z" fill="#9999A7"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.07422 18.75H15.9256C19.2471 18.75 22.0749 16.3336 22.593 13.0527C22.7031 12.3552 22.7031 11.6448 22.593 10.9473C22.0749 7.6664 19.247 5.25 15.9256 5.25H8.07422C4.75272 5.25 1.92485 7.6664 1.40682 10.9473C1.29669 11.6448 1.29669 12.3552 1.40682 13.0527C1.92485 16.3336 4.75272 18.75 8.07422 18.75ZM8.07422 17.25C5.49083 17.25 3.29137 15.3706 2.88846 12.8188C2.8028 12.2763 2.8028 11.7237 2.88846 11.1812C3.29137 8.62942 5.49083 6.75 8.07422 6.75L15.9256 6.75C18.5089 6.75 20.7084 8.62942 21.1113 11.1812C21.197 11.7237 21.197 12.2763 21.1113 12.8188C20.7084 15.3706 18.5089 17.25 15.9256 17.25H8.07422Z" fill="#9999A7"/>
      </svg>
    );
};

export default ToggleOffSVG;
